import classNames from "classnames";
import { RadioConfig } from "../types";
import { InputType } from "shared/form/enum";
import DisplayIcon from "../displayIcon";

function Radio({ type = InputType.RADIO, checked = false, ...props }: RadioConfig) {
  return (
    <div
      className={classNames("radioBtn", {
        "radioBtn--disabled": props.disabled,
        [`radioBtn--${props.variant}`]: props.variant
      })}>
      <label>
        <input
          data-testid={`radio-${props.name}-${props.value}`}
          type={type}
          name={props.name}
          className={classNames("radioBtn_input", props.additionalClassName)}
          value={props.value}
          checked={checked}
          onChange={props.onChange}
          onBlur={props.onBlur}
          disabled={props.disabled}
        />
        <b className="radioBtn_circle smooth" />
        {props.iconUrl && <DisplayIcon iconUrl={props.iconUrl} />}
        <span className="radioBtn_text smooth">{props.label}</span>
      </label>
    </div>
  );
}

export default Radio;
